import { storiesOf } from '@storybook/vue';
import { withKnobs, text, number, boolean } from '@storybook/addon-knobs';

import DmsWrapper from './Wrapper.vue';

const stories = storiesOf('Components/DMS/Form', module);

stories
	.addDecorator(withKnobs)
	.add('Wrapper', () => ({
		components: { DmsWrapper },
		template: `
		<dms-row>
			<dms-wrapper v-bind="$props">
				<el-input :placeholder="placeholder" />
			</dms-wrapper>
		</dms-row>
		`,
		props: {
			showLabel: {
				default: boolean('Zobrazit label', true),
			},
			label: {
				default: text('Label', 'Popis prvku'),
			},
			placeholder: {
				default: text('Placeholder', 'Placeholder...'),
			},
			span: {
				default: number('Velikost v gridu', 12),
			},
			required: {
				default: boolean('Povinné pole', false),
			},
		},
	}), {
		notes: `Obalovací element pro formulářové prvky. Obsahuje případný label prvku. Je možné ho vytvořit jako sloupec v gridu.
			Samostatně (mimo form komponenty) se standardně nepoužívá.`,
	});
